var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfoPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4585 7.29183H13.5418V9.37516H11.4585V7.29183ZM11.4585 11.4585H13.5418V17.7085H11.4585V11.4585ZM12.5002 2.0835C6.75016 2.0835 2.0835 6.75016 2.0835 12.5002C2.0835 18.2502 6.75016 22.9168 12.5002 22.9168C18.2502 22.9168 22.9168 18.2502 22.9168 12.5002C22.9168 6.75016 18.2502 2.0835 12.5002 2.0835ZM12.5002 20.8335C7.90641 20.8335 4.16683 17.0939 4.16683 12.5002C4.16683 7.90641 7.90641 4.16683 12.5002 4.16683C17.0939 4.16683 20.8335 7.90641 20.8335 12.5002C20.8335 17.0939 17.0939 20.8335 12.5002 20.8335Z",
    fill: "#5F59FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoPurple);
export default __webpack_public_path__ + "static/media/icon-info-purple.74f882bc329bf89959a6fbf9c9eb0f7b.svg";
export { ForwardRef as ReactComponent };